export function isBeforePriceUpdateDate() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const julyFirst = new Date(currentYear, 6, 1);
    return currentDate < julyFirst;
}